import { ConstituentLevelConversionData } from "../constituentLevelConversionData.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";

export class constituentLevelConversionSerializerData extends BaseSerializer {

    public deserialize( data: any ): any {
        const gp = new ConstituentLevelConversionData();
        this._copyAttributes(gp, data);
        return gp;

    }

}
